module.exports = __webpack_public_path__ + "img/my_card_bg.36901fa4.png";